import userClient from '../config/api/userClient';
var networkUrl = "gam/listGAMNetwork";
var accountUrl = "gam/account/list";
var lineItemUrl = "gam/inventoryLineItemMapping";
var lineItemsUrl = "gam/listGAMLineItem";
var synchronizeNetworkUrl = "gam/listGAMNetwork/synchronize";
var getOverlapMappingUrl = "gam/inventoryLineItemMapping/getOverlapMappings";
var calculateMappingUrl = "gam/inventoryLineItemMapping/calculate";
var getCreativeAllocationsUrl = "gam/inventoryLineItemMapping/creativeAllocation";
var calculateCreativeAllocationUrl = "gam/inventoryLineItemMapping/calculateCreativeAllocation";
var lineItemMappingOverlapUrl = "gam/inventoryLineItemMapping/turnOnOff";
var publisherNetworkMappingUrl = "gam/listGAMNetworkPublisherMapping";
export var getNetworks = function (params) {
    return userClient.get("" + networkUrl, { params: params });
};
export var getAccounts = function () {
    return userClient.get("" + accountUrl);
};
export var getLineItems = function (params) {
    return userClient.get("" + lineItemUrl, { params: params });
};
export var getMappingById = function (id) {
    return userClient.get(lineItemUrl + "/" + id, {});
};
export var deleteLineItems = function (id) {
    return userClient.delete(lineItemUrl + "/" + id);
};
export var getSynchronizeNetwork = function (params) {
    return userClient.get("" + synchronizeNetworkUrl, { params: params });
};
export var getLineItemLists = function (params) {
    return userClient.get("" + lineItemsUrl, { params: params });
};
export var getOverlapMapping = function (body) {
    return userClient.post("" + getOverlapMappingUrl, body);
};
export var calculateMapping = function (body) {
    return userClient.post("" + calculateMappingUrl, body);
};
export var getCreativeAllocations = function (params) {
    return userClient.get("" + getCreativeAllocationsUrl, { params: params });
};
export var calculateCreativeAllocation = function (body) {
    return userClient.post("" + calculateCreativeAllocationUrl, body);
};
export var createLineItemMapping = function (body) {
    return userClient.post("" + lineItemUrl, body);
};
export var getLineItemCreativeAllocation = function (id) {
    return userClient.get(lineItemUrl + "/" + id + "/creativeAllocation", {});
};
export var getLineItemMappingLog = function (id, params) {
    return userClient.get(lineItemUrl + "/" + id + "/activityLogs", { params: params });
};
export var updateLineItemMapping = function (body, id) {
    return userClient.put(lineItemUrl + "/" + id, body);
};
export var getLineItemMappingOverlap = function (id, params) {
    return userClient.get(lineItemMappingOverlapUrl + "/" + id, { params: params });
};
export var applyLogItem = function (id, params) {
    return userClient.get(lineItemUrl + "/" + id + "/approve", { params: params });
};
export var downloadCSVMappingLog = function (id, params) {
    return userClient.get(lineItemUrl + "/" + id + "/activityLogs/download", { params: params });
};
export var getPublisherMapping = function (params) {
    return userClient.get("" + publisherNetworkMappingUrl, { params: params });
};
